import { useMemo } from 'react';

/**
 * Bỏ dấu, bỏ khoảng trắng, hạ thường — để search khớp bất kể user gõ có dấu,
 * không dấu hay thừa khoảng trắng.
 */
export const normalizeStaffName = (value: string) =>
  (value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/\s+/g, '');

/**
 * Lọc danh sách staff theo từ khoá đã normalize. Trả về chính list gốc khi từ
 * khoá rỗng — giữ reference identity cho consumer.
 */
export const useStaffNameSearch = <T extends { firstName: string }>(
  list: T[],
  keyword: string
) =>
  useMemo(() => {
    const normalizedKeyword = normalizeStaffName(keyword);
    if (!normalizedKeyword) return list;
    return list.filter((o) =>
      normalizeStaffName(o.firstName).includes(normalizedKeyword)
    );
  }, [list, keyword]);

export default useStaffNameSearch;
